<template>
  <div class="py-10 accent-text" :class="`accent-text-section${sectionNumber}`">
    <div class="section-number display-2 font-weight-bold">
      <slot name="main-title"></slot>
    </div>
    <div class="display-2">
      <slot name="title"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    sectionNumber: {
      type: Number,
      required: true
    }
  }
};
</script>